/* eslint-disable */
/**
 * Select all orders
 * @param {any} state The state management `state`
 * @returns {Array<OrderEntity>} The `orders` that have been selected from the store
 */
const ordersSelector = (state) => state.orders;

export default ordersSelector;
